import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Notification } from '~/components/Notification';
import { useCurrentJourney, useJourneyEditErrors } from '~/stores/journeyStore';
import { richLink } from '~/utils/richTextTags';
export function MajorErrorBanner() {
  const $ = _c(5);
  const journeyEditErrors = useJourneyEditErrors();
  const {
    actions
  } = useCurrentJourney();
  const t = useTranslations("content.feedback");
  if (journeyEditErrors?.includes("UNKNOWN_FAILURE")) {
    let t0;
    if ($[0] !== actions.contact || $[1] !== t) {
      t0 = t.rich("trip_error_retrieve", {
        link: richLink({
          hasUnderline: true,
          href: actions.contact,
          isExternal: true,
          target: "_blank",
          className: "font-bold decoration-yellow-800"
        })
      });
      $[0] = actions.contact;
      $[1] = t;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    let t1;
    if ($[3] !== t0) {
      t1 = <div className="px-4 mt-4 mb-4 md:px-0" data-test-id="major-error-banner"><Notification state="error" message={<span>{t0}</span>} /></div>;
      $[3] = t0;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  return null;
}